export function SetDateForInputDate(date: string, isActiveDay = true) {
  let output: any = "";
  const dateStr = date;
  let dateArray = [];
  let yearFirstDateArray = [];
  const slash = dateStr.includes("/");
  const minus = dateStr.includes("-");
  if (slash) {
    dateArray = dateStr.split("/");
    yearFirstDateArray = dateStr.split("/");
  } else if (minus) {
    dateArray = dateStr.split("-");
    yearFirstDateArray = dateStr.split("-");
  } else if (dateStr.length <= 8) {
    if (isActiveDay) {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 2));
      dateArray.push(dateStr.substr(4, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
      yearFirstDateArray.push(dateStr.substr(6, 2));
    } else {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
    }
  } else {
    dateArray = [];
  }
  let day, month, year;
  if (
    yearFirstDateArray.length > 1 &&
    parseInt(yearFirstDateArray[1]) <= 12 &&
    parseInt(yearFirstDateArray[0]) > 1700
  ) {
    if (isActiveDay) {
      day = parseInt(yearFirstDateArray[2]);
      month = parseInt(yearFirstDateArray[1]);
    } else {
      day = 1;
      month = parseInt(yearFirstDateArray[1]);
    }
    year = parseInt(yearFirstDateArray[0]);
    if (year > 2500) {
      year = year - 543;
    }
    const getDaysInMonth = new Date(year, month, 0).getDate();
    if (day <= getDaysInMonth) {
      output = new Date(year, month - 1, day);
    } else {
      output = "";
    }
  }
  if (dateArray.length > 1 && output === "") {
    if (isActiveDay) {
      day = parseInt(dateArray[0]);
      month = parseInt(dateArray[1]);
    } else {
      day = 1;
      month = parseInt(dateArray[0]);
    }
    if (month <= 12) {
      if (isActiveDay && dateArray[2]) {
        year = parseInt(dateArray[2]);
        if (year > 2500) {
          year = year - 543;
        }
      } else if (!isActiveDay && dateArray[1]) {
        year = parseInt(dateArray[1]);
        if (year > 2500) {
          year = year - 543;
        }
      } else {
        year = new Date().getFullYear();
      }
      const getDaysInMonth = new Date(year, month, 0).getDate();
      if (day <= getDaysInMonth) {
        output = new Date(year, month - 1, day);
      } else {
        output = "";
      }
    } else {
      output = "";
    }
  }
  return output;
}
